import useTranslations from "@/shared/lang/useTranslations";

type Stat = {
  label: string;
  value: string;
};

type WalletsStatsStripProps = {
  activeCountries: number;
  cryptoNetworks: number;
};

export const WalletsStatsStrip = ({ activeCountries, cryptoNetworks }: WalletsStatsStripProps) => {
  const { t } = useTranslations("wallets");

  // TODO: re-add USD equivalent from the native rates engine (GET /internal/payments/rates).
  // TODO: add open movements once endpoint exists.
  const stats: Stat[] = [
    { label: t("stat_active_countries"), value: String(activeCountries) },
    { label: t("stat_crypto_networks"), value: String(cryptoNetworks) },
  ];

  return (
    <section className="flex flex-wrap items-center gap-6 rounded-lg border border-border bg-card p-4 shadow-sm">
      {stats.map((stat, idx) => (
        <div key={stat.label} className="flex items-center gap-6">
          {idx > 0 && <div className="h-8 w-px bg-border" />}
          <div>
            <p className="mb-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {stat.label}
            </p>
            <p className="font-mono text-xl font-bold tabular-nums text-foreground">{stat.value}</p>
          </div>
        </div>
      ))}
    </section>
  );
};
